import {Route, Routes} from 'react-router-dom';

import TemplateInvoice from './mau-hoa-don';
import DeclareRegisterInvoice from './to-khai-dang-ky';
import { PrivateRoute } from '../components/PrivateRoute';
import { ROLE } from '../../Constant';
export default function Publish() {

  return (
    <Routes>
      <Route path="mau-hoa-don/*" element={<TemplateInvoice/>}/>
      <Route path="mau-hoa-don/*" element={<PrivateRoute role={ROLE.REGISTER_INVOICE}> <TemplateInvoice/></PrivateRoute>}/>
      <Route path="to-khai-dang-ky/*" element={<PrivateRoute role={ROLE.DECLARE_REGISTER_INVOICE}> <DeclareRegisterInvoice/></PrivateRoute>}/>
    </Routes>
  );
}
